// Button label and click action for a zoom meeting card / details page.
// The API returns status in mixed case ("Upcoming", "ongoing", "Ended"), so compare lowercase.

export type ZoomMeetingAction = 'join' | 'subscribe' | 'recording' | 'none';

export function zoomMeetingStatus(meeting: any): string {
  return meeting && meeting.status ? String(meeting.status).toLowerCase() : '';
}

export function zoomMeetingAction(meeting: any, isSubscribed: any): ZoomMeetingAction {
  const status = zoomMeetingStatus(meeting);
  if (status === 'ongoing' || status === 'upcoming') {
    // Upcoming meetings can be joined too, Zoom keeps the user in the waiting room until the host starts
    return Number(meeting.is_premium) === 1 && !Number(isSubscribed) ? 'subscribe' : 'join';
  }
  if (status === 'ended') {
    return 'recording';
  }
  return 'none';
}

export function zoomMeetingButtonLabel(meeting: any, isSubscribed: any): string {
  const upcoming = zoomMeetingStatus(meeting) === 'upcoming';
  const register = upcoming && meeting.zoom_type === 'EVENT';
  switch (zoomMeetingAction(meeting, isSubscribed)) {
    case 'subscribe':
      return register ? 'Please Subscribe to Register' : 'Please Subscribe to Join';
    case 'join':
      // Upcoming Normal meetings still open the Zoom waiting room when clicked
      return register ? 'Register' : (upcoming ? 'Upcoming' : 'Join');
    case 'recording':
      return 'Watch Recording';
  }
  return zoomMeetingStatus(meeting) === 'cancelled' ? 'Cancelled' : '';
}
